export default {
    HEAT_MAP: "heat_map",
    CATEGORY: "category",
    SUCCESS_COLOR: "success",
    ERROR_COLOR: "error",
    WARNING_COLOR: "warning",
    INFO_COLOR: "info",
};
